import { alpha, makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
  radioGroup: {
    display: 'block',
    width: '100%',
  },
  card: {
    backgroundColor: theme.palette.background.default,
    cursor: 'pointer',
    overflow: 'hidden',
  },
  cardError: {
    borderColor: theme.palette.error.main,
    backgroundColor: alpha(theme.palette.error.main, 0.04),
  },
  error: {
    color: theme.palette.error.main,
  },
  cardLabel: {
    width: '100%',
    paddingInline: theme.spacing(2),
    paddingBlock: theme.spacing(1),
  },
}))

export default styles
